export default "<footer>\n  <p class=\"footer_legal\">© {{ currentYear | date:'yyyy' }} Reserv IT Solutions. All rights reserved. V{{version}}</p>\n</footer>";